import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Lazy load route components for code splitting
const Index = lazy(() => import("./pages/Index"));
const ClaimReport = lazy(() => import("./pages/ClaimReport"));
const ClientZone = lazy(() => import("./pages/ClientZone"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={<div className="flex items-center justify-center min-h-screen">Načítání...</div>}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/klientska-zona" element={<ClientZone />} />
            <Route path="/claim/:id" element={<ClaimReport />} />
            <Route path="/nahlasit-pojistnou-udalost" element={<ClaimReport />} />
            
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
